module.exports = __webpack_public_path__ + "static/media/Banner_ARQUITETURA_DE_NEGÓCIOS_CONCEITOS_E_APLICABILIDADE.a2df6421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquitetura_neg/Banner_ARQUITETURA_DE_NEGÓCIOS_CONCEITOS_E_APLICABILIDADE.png
// module id = 287
// module chunks = 0